/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'

import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cookie from 'react-cookies'
import { StateInitial, User } from '../../utils/models'
import * as S from './styles'
import logo from '../../assets/icons/tj_icon-blue.svg'
// import logo from '../../assets/icons/tj_icon-blue.png'
import symbolColored from '../../assets/icons/colored-symbol.svg'
import logout from '../../assets/icons/logout.svg'
import visibilityIcon from '../../assets/icons/visibility_icon.svg'
import tjIcon from '../../assets/icons/tj_white_icon.svg'
import logoutWhite from '../../assets/icons/logout_white.svg'
import { maskCustomDocument, maskDocument } from '../../utils/altMaskDocument'

interface Data {
  modules: StateInitial
  dispatch: any
}

const Header = ({ modules, dispatch }: Data): any => {
  const history = useHistory()
  const [nameClient, setNameClient] = useState<string | null>()
  const [ucClient, setUcClient] = useState<string | null>()
  const [isDoc, setIsDoc] = useState(false)
  const [adress, setAdress] = useState<string | null>()
  const [showDetailsMobile, setShowDetailsMobile] = useState(false)

  useEffect(() => {
    // const userTemp =  localStorage.getItem('info');
    const userTemp = localStorage.getItem('Invoices')
    // console.log(userTemp,'tempoUser')
    const usersTemp = localStorage.getItem('Refs')
    const refTemp = localStorage.getItem('Ref')
    if (refTemp) {
      const usersInfo = JSON.parse(refTemp) as any

      setAdress(`${usersInfo.description}`)
      if (usersInfo.id) {
        setUcClient(usersInfo.id)
      } else if (usersInfo.doc) {
        setUcClient(usersInfo.doc)
        setIsDoc(true)
      }
    }
  }, [modules])

  function reset(): unknown {
    return {
      type: 'RESET',
    }
  }

  function handleLogout(): void {
    localStorage.clear()
    sessionStorage.clear()
    cookie.remove('OrangeLabs')
    dispatch(reset())
    history.push('/login')
  }

  const maskedClient = isDoc
    ? maskDocument(ucClient || '00000')
    : maskCustomDocument(ucClient || '00000')

  return (
    <S.Container>
      <S.BoxDesktop
        style={{
          maxHeight: showDetailsMobile ? '400px' : '90px',
          transition: '0.3s',
          minHeight: showDetailsMobile ? '400px' : '90px',
        }}
      >
        <div
          id="textTop"
          style={{
            borderBottom: showDetailsMobile ? '0.5px solid #9e9e9e' : 'none',
          }}
        >
          <div className="logoGrid">
            {
              // alterar para generica
            }
            <img src={logo} alt="TJRR" className="logoBig" />
            <img
              style={{ height: 39 }}
              src={symbolColored}
              alt="TJRR"
              className="logoSmall"
            />
          </div>
          <div id="textViewMobile" style={{ gap: 20 }}>
            {ucClient && (
              <div id="uc" style={{ display: 'flex', flexDirection: 'column' }}>
                <S.ContentTitle style={{ overflow: 'hidden' }}>
                  {`${nameClient ? `${nameClient.substr(0, 15)}...` : '-'}`}
                </S.ContentTitle>
                <S.ContentUc>{`UC ${ucClient || '00000'}`}</S.ContentUc>
              </div>
            )}
            <S.Menu
              onClick={() => {
                setShowDetailsMobile(!showDetailsMobile)
              }}
            >
              <FontAwesomeIcon
                style={{
                  transition: '0.3s',
                  transform: showDetailsMobile
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                }}
                icon={faChevronDown}
                color="var(--secondaryColor)"
                size="1x"
              />
            </S.Menu>
          </div>
          <div
            id="textViewPc"
            style={{ flexDirection: 'row', gap: 30, alignItems: 'center' }}
          >
            {ucClient && (
              <div id="uc" style={{ display: 'flex', flexDirection: 'column' }}>
                <S.Label>{isDoc ? 'CPF/CNPJ' : 'Processo PROJUDI'}</S.Label>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '4px',
                  }}
                >
                  <S.Content>{maskedClient}</S.Content>
                </div>
              </div>
            )}

            <S.Logout onClick={handleLogout}>
              <img src={logout} alt="Sair" />
              <p>Sair</p>
            </S.Logout>
            <S.Menu
              onClick={() => {
                setShowDetailsMobile(!showDetailsMobile)
              }}
            >
              <FontAwesomeIcon
                style={{
                  transition: '0.3s',
                  transform: showDetailsMobile
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                }}
                icon={faChevronDown}
                color="var(--secondaryColor)"
                size="1x"
              />
            </S.Menu>
          </div>
        </div>
        <S.BarLoading
          style={{
            height: 2,
            visibility: modules.SEARCH_DB ? 'visible' : 'hidden',
          }}
        />
        <div id="textBody">
          {ucClient && (
            <>
              <S.Label>UNIDADE CONSUMIDORA</S.Label>
              <S.Content>{ucClient || '00000'}</S.Content>
            </>
          )}
          {nameClient && (
            <>
              <S.Label>CLIENTE ATUAL</S.Label>
              <S.Content>{nameClient}</S.Content>
            </>
          )}
          {adress && (
            <>
              <S.Label>ENDEREÇO</S.Label>
              <S.Content>{adress}</S.Content>
            </>
          )}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <S.Logout onClick={handleLogout}>
              <img src={logout} alt="Sair" style={{ height: 20 }} />
            </S.Logout>
            <h3 style={{ color: '#494949' }}>Sair</h3>
          </div>
        </div>
      </S.BoxDesktop>

      <S.HeaderMobile>
        <div />
        <img className="header_img" src={tjIcon} alt="Imagem" />
        <S.Logout onClick={handleLogout}>
          <img src={logoutWhite} alt="Sair" />
          <p>Sair</p>
        </S.Logout>
      </S.HeaderMobile>

      <S.BoxMobile>
        {ucClient && (
          <div id="uc" style={{ display: 'flex', flexDirection: 'column' }}>
            <S.Label>{isDoc ? 'CPF/CNPJ' : 'Processo PROJUDI'}</S.Label>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
              }}
            >
              <S.Content>{maskedClient}</S.Content>
            </div>
          </div>
        )}
      </S.BoxMobile>
    </S.Container>
  )
}

export default connect((state: StateInitial) => ({ modules: state }))(Header)
